import React from 'react';
import { isMobileOnly } from 'react-device-detect';
import classNames from 'classnames';
import { usePaymentContext } from '../../contexts/payment/paymentContext';
import ItemCheckoutButton from './components/ItemCheckoutButton';
import ItemContentCart from './components/ItemContentCart';
import SuccessModal from './components/modals/SuccessModal';
import ErrorModal from './components/modals/ErrorModal';
import ItemContentList from './ItemContentList';

const ItemContent = () => {
  const { transaction, isSuccessful, isError, resetTransaction } = usePaymentContext();
  return (
    <>
      {isError && <ErrorModal onClick={resetTransaction}/>}
      {isSuccessful && <SuccessModal onClick={resetTransaction}/>}
      <div className="item-content">
        <div className="item-content-wrapper">
          <ItemContentCart/>
          <ItemContentList transaction={transaction}/>
          <div className={classNames('item-button-wrapper', { 'mobile': isMobileOnly })}>
            <ItemCheckoutButton transaction={transaction} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemContent;
